namespace $.$$ {
	export class $shm_hitalama_map_widget_float_ai_request extends $.$shm_hitalama_map_widget_float_ai_request {

		that() {
			return this
		}
		
		next_request( next?: any ) {
			this.Form().next_request()
		}

		prompt(): string {
			return this.Form().prompt()
		}

		@ $mol_mem
		request_type( next?: string ): keyof ReturnType< $shm_hitalama_map_widget_float_ai_request['req_type_dict'] > {
			if( next == undefined ) {
				return ( this.widget().ai_request().request_type() || super.request_type() ) as keyof ReturnType< $shm_hitalama_map_widget_float_ai_request['req_type_dict'] >
			}
			this.widget().ai_request().request_type( next )
			return next as keyof ReturnType< $shm_hitalama_map_widget_float_ai_request['req_type_dict'] >
		}

		Form() {
			return this.forms()[ this.request_type() ]
		}
		
		paste() {
			return this.Form().paste()
		}
		
	}

}
